"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EIDAProfileCode = void 0;
var EIDAProfileCode;
(function (EIDAProfileCode) {
    EIDAProfileCode[EIDAProfileCode["EIDA_OK"] = 0] = "EIDA_OK";
    EIDAProfileCode[EIDAProfileCode["GENERAL_ERROR"] = 1] = "GENERAL_ERROR";
    EIDAProfileCode[EIDAProfileCode["AUTH_ERROR"] = 2] = "AUTH_ERROR";
    EIDAProfileCode[EIDAProfileCode["SERVICE_ERROR"] = 3] = "SERVICE_ERROR";
    EIDAProfileCode[EIDAProfileCode["EIDA_REQUIRE_OTP"] = 5] = "EIDA_REQUIRE_OTP";
    EIDAProfileCode[EIDAProfileCode["UNABLE_TO_GET_TOKEN"] = 6] = "UNABLE_TO_GET_TOKEN";
    EIDAProfileCode[EIDAProfileCode["UNABLE_TO_VALIDATE_TOKEN"] = 7] = "UNABLE_TO_VALIDATE_TOKEN";
    EIDAProfileCode[EIDAProfileCode["INVALID_MISSING_EID"] = 8] = "INVALID_MISSING_EID";
    EIDAProfileCode[EIDAProfileCode["INVALID_MISSING_RESIDENCY"] = 9] = "INVALID_MISSING_RESIDENCY";
    EIDAProfileCode[EIDAProfileCode["INVALID_MISSING_MOBILE"] = 10] = "INVALID_MISSING_MOBILE";
    EIDAProfileCode[EIDAProfileCode["INVALID_MISSING_OTP"] = 11] = "INVALID_MISSING_OTP";
    EIDAProfileCode[EIDAProfileCode["INVALID_MISSING_HASH"] = 12] = "INVALID_MISSING_HASH";
    EIDAProfileCode[EIDAProfileCode["OPERATION_SUSPENDED"] = 13] = "OPERATION_SUSPENDED";
})(EIDAProfileCode = exports.EIDAProfileCode || (exports.EIDAProfileCode = {}));
